import styled, { css } from 'styled-components';
import { CleverInput } from 'UI/Input';

const sInvalidInputBorderColor = css<{ $isInvalid?: boolean }>`
  border: ${({ theme, $isInvalid }) => ($isInvalid ? `1px solid ${theme.color.red}` : '')};
`;

const sInvalidInputBackgroundColor = css<{ $isInvalid?: boolean }>`
  background-color: ${({ theme, $isInvalid }) => ($isInvalid ? theme.color.palette_red_1 : '')};
`;

const sInvalidInputColor = css<{ $isInvalid?: boolean }>`
  color: ${({ theme, $isInvalid }) => ($isInvalid ? theme.color.red : '')};
  ::placeholder {
    color: ${({ theme, $isInvalid }) => ($isInvalid ? theme.color.red : '')};
  }
`;

const sInvalidInput = css<{ $isInvalid?: boolean }>`
  ${sInvalidInputBorderColor}
  ${sInvalidInputBackgroundColor}
  ${sInvalidInputColor}
`;

export const SInputTime = styled(CleverInput)<{ $isInvalid?: boolean }>`
  ${sInvalidInput}
`;
